export const ConfirmationMsg = {
  legStatusChange: (previousStatus: string, currentStatus: string) => ConfirmationConfig.legStatusChange.msg(previousStatus, currentStatus),
  differentLegStatusChange: () => ConfirmationConfig.differentLegStatusChange.msg(),
  deleteLinkedSR: () => ConfirmationConfig.deleteLinkedSR.msg(),
  deleteAllLinkedSR: () => ConfirmationConfig.deleteAllLinkedSR.msg(),
  clockInClockOut: (clockType: string) => ConfirmationConfig.clockInClockOut.msg(clockType),
  manageData: (operationType: string, dataType: string, dataName: string) =>
    ConfirmationConfig.manageData.msg(operationType, dataType, dataName),
  removeMember: (firstName: string) => ConfirmationConfig.removeMember.msg(firstName),
  exitGroup: () => ConfirmationConfig.exitGroup.msg(),
  deleteGroup: () => ConfirmationConfig.deleteGroup.msg(),
};

export const ConfirmationConfig = {
  legStatusChange: {
    msg: (prevStatus: string, CurrStatus: string) =>
      `Are you sure you want to change the status from ${prevStatus} to ${CurrStatus}? Your data may be lost`,
  },
  differentLegStatusChange: { msg: () => `Please complete previous leg before starting this leg.` },
  deleteLinkedSR: { msg: () => `Are you sure you want to unlink this service request?` },
  deleteAllLinkedSR: {
    msg: () =>
      `If you unlink this service request, then all the service requests will be unlinked. Are you sure you want to unlink this service request?`,
  },
  clockInClockOut: { msg: (clockType: string) => `Are you sure you want to ${clockType}?` },
  manageData: {
    msg: (operationType: string, dataType: string, dataName: string) =>
      `Are you sure you want to ${operationType} the ${dataType} '${dataName}'?`,
  },
  removeMember: { msg: (firstName) => `Are you sure you want to remove ${firstName} from the group?` },
  exitGroup: { msg: () => `Are you Sure you want to leave the group?` },
  deleteGroup: { msg: () => `Are you sure you want delete the group?` },
};
